var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3E3719D3-6A5B-4E2B-BA54-C18272CA0EDE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admissions",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "admissionsWorkspaceTasksPanel",
    transform: "translate(-1332.000000, -872.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "actionPanel",
    transform: "translate(1055.000000, 795.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "navigationTabs",
    transform: "translate(0.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tab_Navigation/--Tabs/Icon_+_Label",
    transform: "translate(212.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Person/Fill",
    transform: "translate(65.733333, 27.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "24pt_Bounding_Box",
    opacity: 0,
    fillRule: "nonzero",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,13 C15.86599,13 19,16.13401 19,20 L19,20 L18.9932722,20.1166212 C18.9355072,20.61396 18.512836,21 18,21 L18,21 L5.99999996,21 C5.44771496,21 4.99999996,20.5522852 4.99999996,20 L4.99999996,20 L5.00405898,19.7593504 C5.13090141,16.0047865 8.21455141,13 12,13 Z M11.9999998,3 C14.2091398,3 15.9999998,4.79086 15.9999998,7 C15.9999998,9.20914 14.2091398,11 11.9999998,11 L11.9999998,11 L11.8003594,10.9951047 C9.68396735,10.8910789 7.99999983,9.14219578 7.99999983,7 L7.99999983,7 L8.00489513,6.80035957 C8.10892089,4.68396753 9.85780346,3 11.9999998,3 Z",
    id: "Fill"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.0cef704c20a0a709cf1b7fde5ffbd94a.svg";
export { ForwardRef as ReactComponent };